import React from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateInput = ({
  field,
  form,
  maxAllowedDate,
  dateFormat = "MMMM d, yyyy",
  // Pulled OUT of ...props on purpose. react-datepicker treats `value` as the
  // literal text to render in the input, overriding the `dateFormat` applied to
  // `selected` — so a pre-populated field showed the raw stored string
  // ("2026-09-01") instead of the formatted date, and only started rendering
  // properly once the user re-picked. It is still read below for `selected`;
  // it just must not reach DatePicker.
  value: valueProp,
  ...props
}) => {
  const value = field?.value || valueProp;

  return (
    <DatePicker
      {...field}
      // Month and year become dropdowns, and the year list is long and
      // scrollable. Reaching a 1998 warranty date used to mean ~330 clicks on
      // the back arrow. `dropdownMode="scroll"` renders the picker's OWN lists
      // (not native <select>s): the OS menu could not be themed or sized — the
      // year list sprawled across the screen and opened upward while the month
      // opened downward. The picker's lists are dark-skinned globally
      // (styles/style.scss), both open below the header, and the year list is
      // capped + scrollable (Alex, 2026-09-04).
      showMonthDropdown
      showYearDropdown
      dropdownMode="scroll"
      scrollableYearDropdown
      yearDropdownItemNumber={80}
      // Typing a whole date is the fastest input for anyone who knows it. The
      // picker accepts free text by default; these two make it behave: a
      // half-typed date is not coerced into something else, and the calendar
      // follows what has been typed so far.
      strictParsing
      preventOpenOnFocus={false}
      {...props}
      placeholderText={props.placeholder}
      dateFormat={dateFormat}
      selected={(value && new Date(value)) || null}
      onChange={(val) => {
        // A date past the allowed maximum used to hit a bare `return`, which
        // wrote nothing and left the field showing text the form did not have —
        // the box looked filled and saved empty. Clamp to the maximum instead,
        // so what is displayed is always what is stored.
        const next = maxAllowedDate && val && val > maxAllowedDate ? maxAllowedDate : val;

        if (form?.setFieldValue) {
          form.setFieldValue(field?.name, next);
        }
        if (props?.onChange) props.onChange(next);
      }}
      dayClassName={(date) => {
        if (maxAllowedDate && date > maxAllowedDate) {
          return "disabled";
        }
      }}
    />
  );
};

export default DateInput;
